import { render } from "./form.vue?vue&type=template&id=23173cda&scoped=true&ts=true"
import script from "./form.vue?vue&type=script&lang=ts"
export * from "./form.vue?vue&type=script&lang=ts"

import "./form.vue?vue&type=style&index=0&id=23173cda&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23173cda"]])

export default __exports__